import svgUrl from "ni:svgr;M4tLC4BtvpMC87XUb0vQKKxHwgGAmyHMSZBFZY-zHqw";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const OutputLIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><path fill="var(--tbl--colors--icons--output--secondary)" fillRule="evenodd" d="M9 2a4 4 0 0 0-4 4v19a4 4 0 0 0 4 4h9.124A8 8 0 1 1 27 15.755V6a4 4 0 0 0-4-4H9Z" clipRule="evenodd" /><path fill="var(--tbl--colors--icons--output--primary)" fillRule="evenodd" d="M22 30a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-1-11a1 1 0 1 1 2 0v3.586l.293-.293a1 1 0 0 1 1.414 1.414l-2 2a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414l.293.293V19Z" clipRule="evenodd" /></svg>;
const Memo = memo(OutputLIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "OutputLIcon";
}